import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AdminDeleteDepartmentRes;
export const AdminDeleteDepartmentTodo = createAsyncThunk('AdminDeleteDepartment', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `admin/department_admin/${id}`,
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AdminDeleteDepartmentRes = res.data
        
    } catch (error) {
        return AdminDeleteDepartmentRes = error.response.data
    }
})
